import type { Route, RouteConfig } from 'vue-router'
import { _, isAuthorized, piloteAndAuditor } from '@/router/routing'
import MainContent from '@/components/layout/MainContent.vue'
import { risksRoutes } from '@/contexts/risks/Risks.routes'
import { securityBaseRouting } from '@/contexts/security-base/SecurityBase.routes'
import { policiesRoutes } from '@/contexts/policies/Policies.routes'
import { organizationRoutes } from '@/contexts/organization/Organization.routes'

export const strategyRoutes: RouteConfig = {
  path: '/org',
  name: 'organization',
  component: MainContent,
  meta: {
    title: _('Strategy'),
    dummy: true,
    requires_auth: true,
    requires_tenant: true,
    requires_role: piloteAndAuditor,
    is_authorized: (route: Route) => isAuthorized(route),
  },
  children: [securityBaseRouting, organizationRoutes, policiesRoutes, risksRoutes],
}
